//import Guard from '../../services/Middleware'

export default [{
    path: '/Entrar',
    name:'Entrar',
    component: () => import('@/views/login/Login.vue'),
    //beforeEnter: Guard.removeToken
}]
